import {Component, OnInit} from '@angular/core';
import {NgbModalRef} from '../../../shared/components/modal/modal-ref';

@Component({
  selector: 'app-cvs-copay-modal',
  templateUrl: './copay-modal.component.html',
  styleUrls: ['./copay-modal.component.scss']
})
export class CopayModalComponent {

  public modal: NgbModalRef;

  constructor() {
  }

}
